// fastest way to clone date
// https://jsperf.com/clone-date-object2
export function cloneDate(date) {
    return new Date(date.getTime());
}
//# sourceMappingURL=clone.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/ngx-bootstrap/chronos/create/clone.js
// module id = ../../../../ngx-bootstrap/chronos/create/clone.js
// module chunks = 5